import styled from 'styled-components';
import Button from 'antd/lib/button';

export const PresentMapButtonView = styled(Button)`
  position: absolute;
  right: 50px;
  top: 10px;
`;
